import React from "react";
import EN from "../locales/en";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const copyrightText = EN.footer.copyright.replace("{year}", currentYear);
  return (
    <div className="md:h-[98px] bg-[#2648b2] bg-gradient-to-tr from-[#2648b2] to-[#473eac] flex flex-wrap items-center px-7 md:justify-between justify-center md:py-0 py-10 z-10">
      <p className="text-white font-bold text-xs text-center md:text-left md:w-auto w-full mb-6 md:mb-0">
        {copyrightText}
      </p>

      <div className="flex flex-col md:flex-row text-center md:text-right md:space-x-7 md:w-auto w-full space-y-6 md:space-y-0">
        <a href="/faqs" className="text-white font-bold text-xs">
          {EN.footer.faqs}
        </a>
        <a
          href="https://loop.homes/policies/"
          className="text-white font-bold text-xs"
        >
          {EN.footer.policies}
        </a>
        <a
          href="https://kb.loop.homes/"
          className="text-white font-bold text-xs"
        >
          {EN.footer.support}
        </a>
        <a href="https://loop.homes/" className="text-white font-bold text-xs">
          {EN.footer.loophomes}
        </a>
      </div>
    </div>
  );
};

export default Footer;
